import React from 'react';

function Map() {
  return (
    <div className="google-map">
      <iframe
        id="gmap_canvas"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.2776368480936!2d80.19994901728737!3d13.01798369866809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52673a14feac8d%3A0xde1af998726647ca!2s40%2F52%2C%20Navarathna%20Garden%2C%20Ekkatuthangal%2C%20Chennai%2C%20Tamil%20Nadu%20600032!5e0!3m2!1sen!2sin!4v1778212557520!5m2!1sen!2sin"
      ></iframe>
    </div>
  );
}

export default Map;
